import { render } from "./CreateWorkOrderPage.vue?vue&type=template&id=5dd48345&ts=true"
import script from "./CreateWorkOrderPage.vue?vue&type=script&lang=ts"
export * from "./CreateWorkOrderPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__